import { useQuery } from '@tanstack/react-query';
import { getIpaTechAssessments } from '../services/IpaAssessmentService';
import { iimReviewKeys } from './queryKeys';
export function useIpaTechAssessments(inspectionId) {
    return useQuery({
        queryKey: iimReviewKeys.techAssessments(inspectionId),
        queryFn: () => getIpaTechAssessments(inspectionId),
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000
    });
}
